import { Rank } from '../../sim/defs';
import { Fam } from '../../sim/pools/BulletPool';
import { CYCLE, firstDelayAt, PHASE_SALVE } from '../bosses/heraut.cycle';
import { defineEnemy, Motion, Pattern } from '../schema';

/** B01-b — BRAS DU HÉRAUT. Partie destructible, montée par paire (±200 u).
 *
 *  ── Rôle : c'est le bras qui ENSEIGNE ──
 *  Le bras ne se déplace pas de lui-même — il n'en a pas besoin. Il est boulonné
 *  à ±200 u du noyau, et le noyau, lui, poursuit l'abscisse du joueur pendant
 *  les 2,8 premières secondes de chaque cycle (voir le hook dans
 *  bosses/heraut.def.ts). Ce que le joueur VOIT, c'est donc un bras qui vient
 *  vers lui, s'arrête, puis tire.
 *
 *  Cette lecture est exacte et c'est tout l'intérêt : la leçon du combat n'est
 *  pas « esquive la salve », elle est « tu décides d'OÙ elle partira ». Un
 *  joueur qui traîne le boss dans un coin pendant la poursuite, puis traverse
 *  pendant le verrou, rend la salve inoffensive. Personne ne le lui dit ; la
 *  seule pédagogie est la répétition d'un cycle assez lent pour être observé.
 *
 *  ── Pourquoi le bras est la partie la plus dangereuse ──
 *  Éventail VISÉ de 5 projectiles à 460 u/s, tiré simultanément par les deux
 *  bras : deux cônes qui convergent sur la position du joueur au moment du tir.
 *  L'esquive latérale simple ne suffit pas, il faut avoir bougé AVANT. La
 *  famille ROSE l'annonce — c'est celle du Faucheur, apprise au monde 1 : rose
 *  veut dire « ça te suit ».
 *
 *  Détruire les bras en premier retire la seule menace visée du combat, mais
 *  laisse vivre 2 200 PV de canons qui continueront à quadriller le terrain.
 *  C'est le chemin court et nerveux ; les canons d'abord, c'est le chemin long
 *  et sûr. Les deux sont valides — c'est ce qui en fait un choix.
 *
 *  ── Vitesse ──
 *  460 u/s, très loin du plafond de 1 500 (0,80 s de traversée minimum,
 *  MAX_BULLET_SPEED). Un projectile de boss n'a aucune raison d'être rapide :
 *  sa difficulté vient de la géométrie de la volée, jamais du temps de réaction.
 *  Accélérer transforme la lecture en mémorisation. */
export default defineEnemy({
  id: 'heraut-bras',
  rank: Rank.Heavy,
  hp: 1500,
  visualRadius: 34,
  score: 900,
  telegraph: 2.2,
  drops: 4,
  // Ignoré : une partie suit son porteur, elle n'a pas de trajectoire propre.
  motion: { kind: Motion.Hover, speed: 0, amplitude: 0, frequency: 0, holdY: 330 },
  emitter: {
    pattern: Pattern.Aimed,
    every: CYCLE,
    count: 5,
    spreadDeg: 30,
    speed: 460,
    // Une seule salve par cycle, à la phase 3,6 — soit 0,8 s après l'arrêt du
    // porteur. C'est ce décalage qui rend le verrou lisible comme un télégraphe
    // sans coûter le moindre champ supplémentaire au moteur.
    firstDelay: firstDelayAt(PHASE_SALVE),
    family: Fam.EnemyPink,
  },
});
